<script>
    /**
     * This program is free software; you can redistribute it and/or
     * modify it under the terms of the GNU General Public License
     * as published by the Free Software Foundation; under version 2
     * of the License (non-upgradable).
     *
     * This program is distributed in the hope that it will be useful,
     * but WITHOUT ANY WARRANTY; without even the implied warranty of
     * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
     * GNU General Public License for more details.
     *
     * You should have received a copy of the GNU General Public License
     * along with this program; if not, write to the Free Software
     * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
     *
     * Copyright (c) 2022 (original work) Open Assessment Technologies SA ;
     */
    import { useNavigate } from 'svelte-navigator';
    import LazyRoute from './components/LazyRoute/LazyRoute.svelte';
    import schoolSettingsStore from './stores/schoolSettings.js';
    import diagnosticSettingsStore from './stores/diagnosticSettings.js';
    import resultsStore from './stores/results.js';

    const navigate = useNavigate();

    function schoolInfoGuard() {
        if (!$schoolSettingsStore.areRequiredSettingsFilled) {
            navigate('/', { replace: true });
            return false;
        }
        return true;
    }

    function systemCompatibilityGuard() {
        if ($diagnosticSettingsStore.isRunningAudioTest && $resultsStore.audio === null) {
            navigate('/audio-capability', { replace: true });
            return false;
        }
        return schoolInfoGuard();
    }

    function resultsGuard() {
        if ($diagnosticSettingsStore.isRunningAudioTest) {
            if ($resultsStore.audio === null) {
                navigate('/audio-capability', { replace: true });
                return false;
            }
            if (!$resultsStore.audioCompatibility) {
                navigate('/system-compatibility', { replace: true });
                return false;
            }
        } else {
            if (!$resultsStore.browserCompatibility || !$resultsStore.connectionCompatibility) {
                navigate('/system-compatibility', { replace: true });
                return false;
            }
        }
        return true;
    }

    const LoginPage = () => import('./pages/Login.svelte');
    const SystemCompatibilityPage = () => import('./pages/diagnostic/SystemCompatibility.svelte');
    const AudioCapabilityPage = () => import('./pages/diagnostic/AudioCapability.svelte');
    const ResultsPage = () => import('./pages/diagnostic/Results.svelte');
</script>

<LazyRoute path="/system-compatibility" routeComponent={SystemCompatibilityPage} routeGuard={systemCompatibilityGuard} />
<LazyRoute path="/audio-capability" routeComponent={AudioCapabilityPage} routeGuard={schoolInfoGuard} />
<LazyRoute path="/results" routeComponent={ResultsPage} routeGuard={resultsGuard} />
<LazyRoute path="/" routeComponent={LoginPage} />
